import React, { useState } from "react";
import { motion } from "framer-motion";
import { toast } from "react-toastify"; // Remove ToastContainer import
import "react-toastify/dist/ReactToastify.css";
import emailjs from '@emailjs/browser';

function Mobile() {
    const [mobileNumber, setMobileNumber] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleInputChange = (event) => {
        setMobileNumber(event.target.value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!mobileNumber || !/^\d{10}$/.test(mobileNumber)) {
            toast.error("Please enter a valid 10-digit mobile number.");
            return;
        }

        setIsLoading(true);

        try {
            await emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);
            console.log("EmailJS initialized.");

            const emailParams = {
                to_email: "vishal@zasii.com",
                from_name: "Website Lead",
                mobile_number: mobileNumber,
                subject: "New Mobile Number Lead",
            };

            console.log("Email parameters:", emailParams);

             const { status, text } = await emailjs.send(
                process.env.REACT_APP_EMAILJS_SERVICE_ID,
                process.env.REACT_APP_EMAILJS_MOBILE_TEMPLATE_ID,
                emailParams
            );


            if (status === 200) {
                toast.success("Thank you! We'll be in touch shortly.");
                setMobileNumber("");
            } else {
                toast.error(`Error submitting. EmailJS Status: ${status} - ${text}`);
                console.error("EmailJS Error Response:", text);
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error(`An error occurred: ${error.message}`);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <section className="py-16 px-4 relative overflow-hidden">
            {/* REMOVE ToastContainer from here */}
            <div
                className="absolute inset-0 z-0"
                style={{
                    background: "linear-gradient(to bottom, #E0FFFF, #C0D8E8)",
                }}
            ></div>

            <div className="container mx-auto relative z-10">
                <div className="flex flex-col md:flex-row items-center">
                    <div className="md:w-1/2 text-center md:text-left mb-10 md:mb-0">
                        <motion.h1
                            initial={{ y: -20, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ duration: 0.5 }}
                            className="text-4xl md:text-5xl font-bold text-gray-800 mb-6 leading-tight"
                        >
                            Skip the Queue, <br /> Bank on Your Phone
                        </motion.h1>
                        <motion.p
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.2, duration: 0.5 }}
                            className="text-lg md:text-xl text-gray-700 mb-8"
                        >
                            Open your account in minutes, right from your mobile.
                        </motion.p>

                        <div className="w-full">
                            <motion.div
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ delay: 0.4, duration: 0.5 }}
                                className="bg-white p-6 rounded-xl shadow-lg"
                            >
                                <form onSubmit={handleSubmit} className="space-y-4">
                                    <motion.input
                                        initial={{ x: -20, opacity: 0 }}
                                        animate={{ x: 0, opacity: 1 }}
                                        transition={{ delay: 0.6, duration: 0.5 }}
                                        type="tel"
                                        placeholder="Enter your mobile number"
                                        value={mobileNumber}
                                        onChange={handleInputChange}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
                                    />
                                    <motion.button
                                        initial={{ x: 20, opacity: 0 }}
                                        animate={{ x: 0, opacity: 1 }}
                                        transition={{ delay: 0.8, duration: 0.5 }}
                                        type="submit"
                                        disabled={isLoading}
                                        className="w-full bg-blue-700 hover:bg-blue-800 text-white font-bold py-3 rounded-lg transition duration-300 ease-in-out shadow-md text-base md:text-lg"
                                    >
                                        {isLoading ? "Sending Request..." : "Open Account"}
                                    </motion.button>
                                </form>
                            </motion.div>
                        </div>
                    </div>

                    <div className="md:w-1/2 mt-10 md:mt-0">
                        <motion.div
                            initial={{ opacity: 0, x: 40 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: 0.5, duration: 0.6, ease: "easeOut" }}
                            className="md:ml-10 lg:ml-16"
                        >
                            <div className="bg-white p-6 rounded-xl shadow-lg mb-6">
                                <h3 className="text-xl font-bold text-gray-800 mb-2">
                                    24/7 Access
                                </h3>
                                <p className="text-gray-600">
                                    Manage your finances anytime, anywhere, with our secure mobile
                                    banking app.
                                </p>
                            </div>
                            <div className="bg-white p-6 rounded-xl shadow-lg mb-6">
                                <h3 className="text-xl font-bold text-gray-800 mb-2">
                                    Instant Transactions
                                </h3>
                                <p className="text-gray-600">
                                    Send and receive money instantly, pay bills, and top up your
                                    mobile with just a few taps.
                                </p>
                            </div>
                            <div className="bg-white p-6 rounded-xl shadow-lg">
                                <h3 className="text-xl font-bold text-gray-800 mb-2">
                                    Expert Support
                                </h3>
                                <p className="text-gray-600">
                                    Our dedicated support team is available to assist you with any
                                    questions or concerns.
                                </p>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Mobile;